export const shouldLoad = () => document.querySelector('.klt-site--standard--meinklett-table--table') !== undefined;